import { propTypes } from "@sanity/block-content-to-react";
import React, { useState } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './tabs.module.css';
import TabAccordionItem from "./tabAccordionItem";

function tabItem(props) {

    let tabClass = styles.tabItem+' tbi-tab-item';

    if(props.activeTab == props.index){
        tabClass += ' tbi-active '+styles.tabItem__active
    }

    if(props.item.accordion){

        return (
            <div className={tabClass} data-tbindex={'tbi-'+props.index}>

                <div className={styles.accordionWrap}>
                    {
                        props.item.accordion.map((item, i) => {
                            return <TabAccordionItem item={item} key={i} index={'tac-'+props.index+'-'+i} />
                        })
                    }
                </div>

            </div>
        );


    } else {
        return (
            <div className={tabClass}></div>
        );
    }
}
  
export default tabItem;